import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh', paddingTop: '80px' }}>
      {/* Header Spacing */}
      <div style={{ height: '80px' }} />

      <div
        style={{
          maxWidth: '900px',
          margin: '0 auto',
          padding: '60px 7.6923%',
        }}
      >
        {/* Back Button */}
        <button
          onClick={() => navigate('/')}
          style={{
            background: 'transparent',
            border: '1px solid var(--border-subtle)',
            color: 'var(--text-primary)',
            padding: '12px 24px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
            marginBottom: '40px',
            fontSize: '16px',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'var(--brand-hover)';
            e.target.style.borderColor = 'var(--brand-primary)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent';
            e.target.style.borderColor = 'var(--border-subtle)';
          }}
        >
          <ArrowLeft size={20} />
          Kembali ke Beranda
        </button>

        {/* Title */}
        <h1
          style={{
            fontSize: '48px',
            fontWeight: 600,
            color: 'var(--text-primary)',
            marginBottom: '16px',
          }}
        >
          Kebijakan Privasi
        </h1>
        <p
          style={{
            fontSize: '18px',
            color: 'var(--text-muted)',
            marginBottom: '40px',
          }}
        >
          Terakhir diperbarui: {new Date().toLocaleDateString('id-ID', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        {/* Content */}
        <div style={{ color: 'var(--text-secondary)', lineHeight: 1.8, fontSize: '16px' }}>
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              1. Pendahuluan
            </h2>
            <p style={{ marginBottom: '16px' }}>
              BAiBOT inDriver ("kami", "kami", atau "milik kami") menghargai privasi Anda dan berkomitmen untuk melindungi data pribadi Anda. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi Anda saat menggunakan aplikasi BAiBOT inDriver.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              2. Informasi yang Kami Kumpulkan
            </h2>
            
            <h3 style={{ fontSize: '22px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '12px', marginTop: '24px' }}>
              2.1 Device ID
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Kami mengumpulkan Device ID unik perangkat Android Anda untuk:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Mengidentifikasi dan memverifikasi akses Anda ke aplikasi</li>
              <li>Mencegah penggunaan tidak sah (Anti-Hack Protection)</li>
              <li>Mengelola langganan dan masa aktif akun Anda</li>
              <li>Membatasi akses per perangkat sesuai paket yang dibeli</li>
            </ul>

            <h3 style={{ fontSize: '22px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '12px', marginTop: '24px' }}>
              2.2 Data Pengaturan Aplikasi
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Kami menyimpan preferensi dan pengaturan aplikasi Anda secara lokal di perangkat, termasuk:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Filter harga minimum dan maksimum</li>
              <li>Pengaturan area kerja</li>
              <li>Preferensi jarak dan rating</li>
              <li>Konfigurasi Auto Up Price</li>
              <li>Pengaturan otomasi lainnya</li>
            </ul>

            <h3 style={{ fontSize: '22px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '12px', marginTop: '24px' }}>
              2.3 Data Statistik Penggunaan
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Untuk fitur Leaderboard Penghasilan, kami dapat mengumpulkan data statistik anonim seperti:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Jumlah pesanan yang diterima</li>
              <li>Penghasilan harian/mingguan (opsional)</li>
              <li>Statistik performa umum</li>
            </ul>
            <p style={{ marginBottom: '16px', fontWeight: 600, color: 'var(--brand-primary)' }}>
              Data ini bersifat anonim dan tidak terkait dengan identitas pribadi Anda.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              3. Informasi yang TIDAK Kami Kumpulkan
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Kami ingin menegaskan bahwa kami TIDAK mengumpulkan atau menyimpan:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Nomor telepon atau email pribadi Anda</li>
              <li>Kredensial login inDriver Anda</li>
              <li>Password atau informasi autentikasi inDriver</li>
              <li>Data lokasi GPS real-time</li>
              <li>Kontak atau galeri foto Anda</li>
              <li>Percakapan atau pesan pribadi</li>
              <li>Data pembayaran atau informasi kartu kredit</li>
              <li>Informasi penumpang atau detail pesanan spesifik</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              4. Penggunaan Accessibility Service
            </h2>
            <p style={{ marginBottom: '16px' }}>
              BAiBOT inDriver menggunakan Android Accessibility Service untuk menjalankan fungsi otomasi. Izin ini digunakan HANYA untuk:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Membaca informasi pesanan yang muncul di aplikasi inDriver</li>
              <li>Melakukan tindakan otomatis (accept/skip) sesuai preferensi Anda</li>
              <li>Mengoperasikan fitur Auto Up Price dan filter lainnya</li>
            </ul>
            <p style={{ marginBottom: '16px', fontWeight: 600, color: 'var(--brand-primary)' }}>
              PENTING: Kami TIDAK menggunakan Accessibility Service untuk mengakses aplikasi lain, membaca pesan pribadi, atau mengumpulkan data di luar fungsi otomasi pesanan inDriver.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              5. Bagaimana Kami Menggunakan Informasi
            </h2>
            <p style={{ marginBottom: '16px' }}>Informasi yang kami kumpulkan digunakan untuk:</p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Menyediakan dan mengoperasikan layanan otomasi BAiBOT inDriver</li>
              <li>Memverifikasi dan mengelola akses berbasis Device ID</li>
              <li>Mencegah penyalahgunaan dan akses tidak sah</li>
              <li>Meningkatkan performa dan fitur aplikasi</li>
              <li>Memberikan dukungan teknis kepada pengguna</li>
              <li>Menampilkan statistik anonim di Leaderboard (jika diaktifkan)</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              6. Penyimpanan Data
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Sebagian besar data Anda (pengaturan, preferensi) disimpan secara lokal di perangkat Anda. Device ID disimpan di server kami untuk tujuan verifikasi akses dan keamanan.
            </p>
            <p style={{ marginBottom: '16px' }}>
              Kami menyimpan data hanya selama diperlukan untuk menyediakan layanan dan sesuai dengan periode langganan Anda.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              7. Berbagi Informasi dengan Pihak Ketiga
            </h2>
            <p style={{ marginBottom: '16px', fontWeight: 600, color: 'var(--brand-primary)' }}>
              Kami TIDAK menjual, menyewakan, atau membagikan informasi pribadi Anda kepada pihak ketiga untuk tujuan pemasaran atau komersial.
            </p>
            <p style={{ marginBottom: '16px' }}>
              Kami hanya dapat membagikan informasi jika:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Diwajibkan oleh hukum atau perintah pengadilan</li>
              <li>Diperlukan untuk melindungi hak dan keamanan kami</li>
              <li>Anda memberikan persetujuan eksplisit</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              8. Keamanan Data
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Kami menerapkan langkah-langkah keamanan untuk melindungi informasi Anda:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Sistem Anti-Hack dan Device ID Protection</li>
              <li>Enkripsi data saat transmisi</li>
              <li>Akses terbatas ke data pengguna</li>
              <li>Monitoring aktivitas mencurigakan</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              Namun, tidak ada metode transmisi atau penyimpanan elektronik yang 100% aman. Kami tidak dapat menjamin keamanan absolut.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              9. Hak Anda
            </h2>
            <p style={{ marginBottom: '16px' }}>Anda memiliki hak untuk:</p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Mengetahui data apa yang kami kumpulkan tentang Anda</li>
              <li>Meminta penghapusan data Anda dari sistem kami</li>
              <li>Mengubah atau memperbarui pengaturan privasi Anda</li>
              <li>Berhenti menggunakan aplikasi kapan saja</li>
              <li>Menghubungi kami untuk pertanyaan terkait privasi</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              Untuk mengajukan permintaan terkait data Anda, silakan hubungi kami melalui WhatsApp 085175369335.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              10. Kebijakan untuk Anak-anak
            </h2>
            <p style={{ marginBottom: '16px' }}>
              BAiBOT inDriver tidak ditujukan untuk pengguna di bawah usia 18 tahun. Kami tidak dengan sengaja mengumpulkan informasi dari anak-anak. Jika Anda adalah orang tua dan menyadari bahwa anak Anda telah memberikan informasi kepada kami, silakan hubungi kami.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              11. Perubahan Kebijakan Privasi
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu. Kami akan memberitahu Anda tentang perubahan signifikan melalui aplikasi atau website kami. Tanggal "Terakhir diperbarui" di bagian atas halaman ini menunjukkan kapan kebijakan terakhir kali direvisi.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              12. Hubungi Kami
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Jika Anda memiliki pertanyaan atau kekhawatiran tentang Kebijakan Privasi ini, silakan hubungi kami:
            </p>
            <ul style={{ marginLeft: '24px', listStyle: 'none' }}>
              <li style={{ marginBottom: '8px' }}>WhatsApp: 085175369335</li>
              <li style={{ marginBottom: '8px' }}>Telegram: https://t.me/realbai</li>
              <li>WhatsApp Group: https://chat.whatsapp.com/Blx1Cc3PeBc4oJSdg1opyT</li>
            </ul>
          </section>

          <div
            style={{
              background: 'rgba(0, 255, 209, 0.05)',
              border: '1px solid rgba(0, 255, 209, 0.2)',
              padding: '24px',
              marginTop: '60px',
            }}
          >
            <p style={{ fontSize: '16px', color: 'var(--text-secondary)', margin: 0, lineHeight: 1.6 }}>
              <strong style={{ color: 'var(--brand-primary)' }}>Komitmen Kami:</strong> Privasi Anda adalah prioritas kami. Kami berkomitmen untuk melindungi data Anda dan hanya menggunakannya untuk tujuan yang dijelaskan dalam kebijakan ini. Kami tidak akan pernah menjual atau menyalahgunakan informasi pribadi Anda.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
